<template>
  <div id="Opportunities_WhyLA">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>

    <usc-intro :copy="this.intro"></usc-intro>

    <div class="body mb gutter-lg">
      <p><i>In L.A., fresh ideas routinely turn into transformative business ventures, from large commercial enterprises to startups, and in every field from biotech to new media. Whatever your interests, you’ll find inspiration in this dynamic city.</i></p>
      <p>One of the most economically powerful cities in the world, Los Angeles County is home to 22 Fortune 500 companies, including Walt Disney and Amgen. California has 55 Fortune 500 companies. At Marshall, you’ll have the opportunity to meet with top executives from a host of business sectors — as guest speakers, as mentors, at career fairs and as part of your internships and volunteer work.</p>
      <p><strong>Diversity</strong></p>
      <p>A vibrant melting pot, Los Angeles County is also one of the most diverse metropolitan areas in the country. It also has among the largest number of foreign-born residents in the U.S. USC reflects the diversity of the greater Los Angeles area and has one of the largest international student bodies of any U.S. university. USC offers you the opportunity to learn and grow in a city that best resembles the world where you will eventually thrive as professionals.</p>
    </div>

    <!-- <usc-statement class="mb" :bg="this.page.color">
      <h2 slot="title">Diversity</h2>
      <p slot="paragraph">A vibrant melting pot, Los Angeles County is considered the most diverse metropolitan area in the country. It also has the largest number of foreign-born residents in the U.S. USC reflects the diversity of the greater Los Angeles area and has more international students than any other U.S. university.</p>
    </usc-statement> -->

    <usc-dataviz :data="dataViz">
      <h3 slot="title">Los Angeles' Cultural Tapestry</h3>
      <svg slot="svg" class="scaling-svg" xmlns="http://www.w3.org/2000/svg" width="322" height="322" viewBox="0 0 322 322">
        <path fill="#323233" d="M161 160.99L130.471 3.939C140.88 1.916 150.396 1 161 1v159.99z"/>
        <path fill="#777" d="M161 160.99L58.154 38.431C79.815 20.256 102.713 9.335 130.471 3.94L161 160.99z"/>
        <path fill="#CBCBCB" d="M161 160.99H1c0-49.482 19.246-90.753 57.154-122.559L161 160.99z"/>
        <path fill="#96040C" d="M161 160.99l22.268 158.433C95.762 331.72 14.855 270.757 2.557 183.256 1.573 176.256 1 168.059 1 160.99h160z"/>
        <path fill="#FDCA2F" d="M161 160.99V1c88.366 0 160 71.63 160 159.99 0 81.291-57.227 147.119-137.732 158.433L161 160.99z"/>
      </svg>
    </usc-dataviz>

  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import Cta from '@/components/Cta'
import Statement from '@/components/Statement'
import DataViz from '@/components/DataViz'

export default {
  name: 'WhyLA',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': Cta,
    'usc-statement': Statement,
    'usc-dataviz': DataViz
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'L.A. Advantages',
        loResSrc: '../../../static/HeroImages/Advantages3.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages3.jpg'
      },
      intro: [
        'During our first century, Marshall and our graduates helped establish Los Angeles’ position as the world’s entertainment capitol, a major financial center and an innovator in industries ranging from aerospace and biotechnology to transportation and technology. Our alumni are leading entrepreneurs, executives and pacesetters in Southern California and in every corner of the planet. With more than 91,000 Marshall graduates, that global influence is vast! But it all started here in Los Angeles.'
      ],
      dataViz: [
        {
          color: '#ffcc00',
          labelBold: '48%',
          labelSmall: 'Hispanic or Latino'
        },
        {
          color: '#990000',
          labelBold: '29%',
          labelSmall: 'White, Non-Hispanic'
        },
        {
          color: '#cbcbcb',
          labelBold: '12%',
          labelSmall: 'Asian / Pacific Islander'
        },
        {
          color: '#464646',
          labelBold: '9%',
          labelSmall: 'African-American'
        },
        {
          color: '#323233',
          labelBold: '2%',
          labelSmall: 'Indigenous / Others'
        }
      ]
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Why Los Angeles is the Place to Be')
  }
}
</script>

<style scoped lang="scss">
@import '~tiny-slider/src/tiny-slider';
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/life-at-marshall/WhyLA.vue